import stateTerritoryData from './states.js';
import applicationConfigData from './config.js';
import urlHashParams from './url-hash-params.js';
import cartService from './cart-service.js';
import upsellCartService from './upsell-cart-service.js';
import errorHandler from './error-handler.js';
import campaignHistory from './campaign-history.js';
import userDataService from './user-data-service.js';
import UserDataService from './user-data-service.js';
import CurrencyService from './currency-service.js';
import AbandonedCartService from './abandoned-cart.js';

export default angular.module('cui.data', [])
  .service('CampaignHistory', campaignHistory)
  .service('UserDataService', UserDataService)
  .service('CurrencyService', CurrencyService)
  .factory('StateTerritoryData', stateTerritoryData)
  .factory('ApplicationConfigData', applicationConfigData)
  .factory('UrlHashParams', urlHashParams)
  .service('CartService', cartService)
  .service('UpsellCartService', upsellCartService)
  .factory('ErrorHandler', errorHandler)
  .service('UserDataService', userDataService)
  .service('AbandonedCartService', AbandonedCartService)
;



// WEBPACK FOOTER //
// ./source/client/data-providers/index.js